import http from "../config/axios";

interface updateProductsInRestaurantProps {
    restaurantId: string;
    productId: string;
    requestBody: Object;
}
interface updateOrderInProductsProps {
    restaurantId: string;
    order_products: Object;
}
export async function updateProductsInRestaurant({ restaurantId, productId, requestBody }: updateProductsInRestaurantProps) {
    const url = `/restaurants/product/${productId}/${restaurantId}`;

    try {
        const response = await http.put(url, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error: any) {
        console.error('Error making the request:', error);
        throw new Error(`Update product failed: ${error.message || 'Some error occurred'}`);
    }
}

export async function updateOrderInProducts({ restaurantId, order_products }: updateOrderInProductsProps) {
    const url = `/restaurant_showcase/update_sequence/${restaurantId}`;
    console.log('order_products', order_products);
    try {
        const response = await http.put(url, order_products, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    }
    catch (error: any) {
        console.error('Error making the request:', error);
        throw new Error(`Update product failed: ${error.message || 'Some error occurred'}`);
    }
}

export async function update_List_Of_Products({ restaurantId, requestBody }: { restaurantId: string, requestBody: Array<Object> }) {
    const url = `/restaurants/product-list-to-update/${restaurantId}`;

    try {
        const response = await http.put(url, requestBody, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error: any) {
        console.error('Error making the request:', error);
        throw new Error(`Update product failed: ${error.message || 'Some error occurred'}`);
    }
}


export async function create_product_restaurant ({ product }: any) {
    try {
        const response = await http.request({
            method: "POST",
            url: `/product_restaurant/create`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: product
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao criar produto:", error);
        throw error;
    }
}

export async function create_restaurant_showcase ({ showcase }: any) {
    try {
        const response = await http.request({
            method: "POST",
            url: `/restaurant_showcase/create`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: showcase
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao criar vitrine:", error);
        throw error;
    }
}

export async function listRestaurantShowcases({restaurantId, limit = 100, offset = 0}:any) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/restaurant_showcase/list_showcase/${restaurantId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar as vitrines do restaurante:", error);
        throw error;
    }
}

export async function update_restaurant_showcase({ showcaseId, requestBody }: any) {
    try {
        const response = await http.request({
            method: "PATCH",
            url: `/restaurant_showcase/update/${showcaseId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: requestBody
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar vitrine:", error);
        throw error;
    }
}


export async function listProductRestaurant({ limit = 100, offset = 0, type = "" }) {
    try {
        const paramType = type === 'regular' ? '&type=regular&type=combo' : `&type=${type}`;
        const response = await http.request({
            method: "GET",
            url: `/product_restaurant/list?limit=${limit}&offset=${offset}${paramType}`,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar produtos do restaurante:", error);
        throw error;
    }
}

export async function getProductCompleteInfo({ productId, restaurantId }:any) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/product_restaurant/detail/${productId}/${restaurantId}`,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar produto:", error);
        throw error;
    }
}

export async function update_product_restaurant({ productId, requestBody }: any) {
    try {
        const response = await http.request({
            method: "PATCH",
            url: `/product_restaurant/update/${productId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: requestBody
        });
        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar produto:", error);
        throw error;
    }
}

export async function list_product_additional_compositions({ limit = 100, offset = 0 }) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/product_additional_composition/list`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar produtos adicionais:", error);
        throw error;
    }
}

export async function list_product_complement_compositions({ limit = 100, offset = 0 }) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/product_complement_composition/list`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar produtos complementares:", error);
        throw error;
    }
}


export async function listProductsByCategory({ categoryId, limit = 100, offset = 0}:any) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/product_category/detail/${categoryId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset
            }
        });
        
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar categorias de produtos:", error);
        throw error;
    }
}

export async function listProductCategories({ limit = 100, offset = 0}) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/product_category/list`,
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                limit,
                offset
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar categorias de produtos:", error);
        throw error;
    }
}

export async function update_product_category({ categoryId, requestBody }: any) {
    try {
        const response = await http.request({
            method: "PATCH",
            url: `/product_category/update/${categoryId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: requestBody
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar categoria de produto:", error);
        throw error;
    }
}

export async function getInfosShowCaseProduct({ showcaseId }: any) {
    try {
        const response = await http.request({
            method: "GET",
            url: `/restaurant_showcase/detail/${showcaseId}`,
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao buscar informações da vitrine:", error);
        throw error;
    }
}

export async function updateProductShowCase({ showcaseId, requestBody }: any) {
    try {
        const response = await http.request({
            method: "PATCH",
            url: `/restaurant_showcase/update/${showcaseId}`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: requestBody
        });

        return response.data;
    } catch (error) {
        console.error("Erro ao atualizar produto da vitrine:", error);
        throw error;
    }
}